








































import { Component, Vue, Watch } from 'vue-property-decorator';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import CreateFaqCategoryRequest from '@/models/FaqCategories/CreateFaqCategoryRequest';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';

@Component({
    name: 'FaqCategoryCreate'
})
export default class extends GiganautVueDialog {
 
  public entity = new CreateFaqCategoryRequest();

  @Watch('dialog')
  onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.entity = new CreateFaqCategoryRequest();
    }
  }

  get loading() {
    return AgencySettingsModule.loadingDialog;
  }

  async save() {
     if (!(this.$refs.form as any).validate()) {
      return;
    }
       
    await AgencySettingsModule.createFaqCategory(this.entity)
    this.dialog = false;
  }
}
